import {
  Button,
  Pagination,
  Table,
  Tag,
  Input,
  Popconfirm,
  message,
} from "antd";
import React, { useEffect, useState } from "react";
import { ExtractDate, ExtractTime, messageConfiguration } from "../../../utils";
import { useLocation } from "react-router-dom";
import ComponentTitle from "../../../Common/ComponentTitle";
import { deleteContactData, getContactData } from "./ContactApiFunction";
import { DeleteOutlined } from "@ant-design/icons";

const ContactUS = () => {
  const [ContactData, setContactData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [totalPage, setTotalPages] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const { Search } = Input;
  const location = useLocation();
  const from = location.state?.from;
  const pageSize = 10;
  console.log(from);
  function FetchContactUSDetails(currentPage) {
    setIsLoading(true);
    getContactData(`?search=${searchTerm}&page=${currentPage}&limit=10`)
      // `isActive=1&isApproved=${approved}&isRejected=${rejected}&request_name=${searchTerm}&page=${currentPage}`
      .then((response) => {
        if (response.status) {
          setContactData(response.data?.data);
          setCurrentPage(response.data?.pagination.currentPage);
          setTotalPages(response.data?.pagination.totalPages);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("error", err);
        setIsLoading(false);
      });
  }

  useEffect(() => {
    FetchContactUSDetails(currentPage);
  }, [currentPage, searchTerm]);

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
  };
  function DeleteAction(checked, record) {
    let payload = {
      contactUsId: record.id,
    };
    deleteContactData(payload)
      .then((response) => {
        if (response.data.status) {
          message.open(
            messageConfiguration("success", response.data.message, 3)
          );
          FetchContactUSDetails(currentPage);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  const columnReports = [
    {
      title: "SNo.",
      dataIndex: "serial",
      key: "serial",
      className: "custom-header font-poppins text-xs",
      render: (data, record, index) => {
        return (
          <p className="text-xs font-poppins text-rgbaprimary9 font-semibold">
            {index + 1 + (currentPage - 1) * pageSize}.
          </p>
        );
      },
    },
    {
      title: "User Name",
      dataIndex: "name",
      key: "name",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => {
        return (
          <>
            <p className="text-xs font-poppins">
              {record?.name?.toUpperCase() ?? "--"}
            </p>
          </>
        );
      },
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => {
        return (
          <>
            <p className="text-xs font-poppins">{record?.email ?? "--"}</p>
          </>
        );
      },
    },

    {
      title: "Message",
      dataIndex: "message",
      key: "message",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => {
        return (
          <>
            <p className="text-xs font-poppins">{data ?? "--"}</p>
          </>
        );
      },
    },

    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => {
        return (
          <>
            <p className="text-xs font-poppins">
              {ExtractDate(record.createdAt)}.{ExtractTime(record.createdAt)}
            </p>
          </>
        );
      },
    },
    {
      title: "Delete",
      dataIndex: "delete",
      key: "delete",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => (
        <Popconfirm
          title={
            <div>
              <p style={{ marginBottom: "8px", fontWeight: "bold" }}>
                Are you sure you want to delete this Contact?
              </p>
            </div>
          }
          onConfirm={() => DeleteAction(undefined, record)}
          okText="Delete"
          cancelText="Cancel"
        >
          <DeleteOutlined
            className="text-xs font-poppins font-bold w-1/2 text-center rounded-full cursor-pointer text-rgbaprimary9"
            title="Delete"
          />
        </Popconfirm>
      ),
    },
  ];

  return (
    <div>
      <ComponentTitle title={"Contact List"} />
      <div className="flex items-end justify-end m-2">
        <Search
          placeholder="search here..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ width: "25%" }}
        />
      </div>
      <div
        style={{ maxHeight: "540px", overflow: "auto" }}
        className="bg-white shadow-md  shadow-[rgba(149, 157, 165, 0.2) 0px 8px 24px]"
      >
        <Table
          bordered={true}
          loading={isLoading}
          columns={columnReports}
          dataSource={ContactData}
          pagination={false}
          className="w-screen sm:w-screen custom-table-header"
          size="small"
        />
      </div>
      <Pagination
        className="mt-2 text-xs w-full flex justify-center items-center"
        onChange={handlePageChange}
        current={currentPage}
        defaultCurrent={1}
        pageSize={pageSize}
        total={10 * totalPage}
        showSizeChanger={false}
      />
    </div>
  );
};
export default ContactUS;
